import Applicant from './Models/Applicant'

Vue.prototype.$models.$applicant = new Vue(Applicant)

Vue.component('applicants-table', () => import(/* webpackChunkName: "applicants-table" */ '@modulesPages/Applicant/Resources/assets/js/Tables/ApplicantsTable'))

Vue.component('applicants-form', () => import(/* webpackChunkName: "applicants-form" */ '@modulesPages/Applicant/Resources/assets/js/Forms/Applicants/ApplicantsForm'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Applicant\\Entities\\Applicant': 'Aplicante',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Applicant\\Entities\\Applicant': 'applicants',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'applicants': 'Modules\\Applicant\\Entities\\Applicant',
    }   
}